import React from 'react';
import { Col, Row } from 'components/Core/Grid';
import Button from 'components/Core/Button';
import Grid from './Grid';
import { Container, InnerContainer } from './styles';

const FeatureBlocksLottie = ({ title, subtitle }) => {
  const button = ({ className }) => (
    <Button
      type="transparent - white border"
      width="100%"
      shadow={false}
      button
      to="/field-service-management-software"
      ctaPosition="ctabutton"
      className={className}
    >
      Learn more
    </Button>
  );
  return (
    <Container>
      <InnerContainer>
        <Row gutter={[60, 30]} justify="space-between" align="middle" className="row-container">
          <Col xs={24} md={10} xxl={9}>
            <h2>{title}</h2>
            <p>{subtitle}</p>
            {button({ className: 'min-md' })}
          </Col>
          <Col xs={24} md={13} lg={13} className="col-grid-container">
            <Row justify="center" align="middle">
              <Grid />
            </Row>
            {button({ className: 'max-md' })}
          </Col>
        </Row>
      </InnerContainer>
    </Container>
  );
};

export default FeatureBlocksLottie;
